import { render, staticRenderFns } from "./ReportDisplay.vue?vue&type=template&id=6020e4f9&scoped=true&"
import script from "./ReportDisplay.vue?vue&type=script&lang=js&"
export * from "./ReportDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ReportDisplay.vue?vue&type=style&index=0&id=6020e4f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6020e4f9",
  null
  
)

export default component.exports